(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class PlantaTabFilter {
    constructor() {
      if (!document.querySelector('.planta-type-tabs')) return;

      this.grid = document.querySelector('results-list');
      if (!this.grid) return;

      this.sectionId = this.grid.getAttribute('section-id');
      this.busy = false;

      // Set correct active tab on initial load from URL
      this.syncActiveTab(window.location.pathname);

      // Use event delegation on document so clicks work after innerHTML swaps
      // (innerHTML replacement detaches this.nav, making direct listeners dead)
      document.addEventListener('click', (e) => {
        const tab = e.target.closest('.planta-type-tab');
        if (!tab || this.busy) return;
        e.preventDefault();
        this.fetchAndSwap(tab.href, true);
      });

      window.addEventListener('popstate', () => {
        this.fetchAndSwap(window.location.href, false);
      });
    }

    // Derive the active tab purely from the URL path — never trust server-rendered active state.
    // Always re-queries the live DOM so it works correctly after innerHTML swaps.
    // Syncs ALL .planta-type-tabs navs (desktop + mobile duplicate).
    syncActiveTab(urlPath) {
      const navs = document.querySelectorAll('.planta-type-tabs');
      if (!navs.length) return;

      const segments = urlPath.split('/').filter(Boolean);
      // /collections/all/tees → tag = 'tees'; /collections/all → tag = null
      const tag = segments.length > 2 ? segments[segments.length - 1].toLowerCase() : null;

      navs.forEach(nav => {
        nav.querySelectorAll('.planta-type-tab').forEach(tab => {
          const tabSegments = new URL(tab.href).pathname.split('/').filter(Boolean);
          const tabTag = tabSegments.length > 2 ? tabSegments[tabSegments.length - 1].toLowerCase() : null;
          const isActive = tag ? tabTag === tag : !tabTag || tabTag === 'all';
          tab.classList.toggle('planta-type-tab--active', isActive);
        });
      });
    }

    async fetchAndSwap(url, pushState) {
      this.busy = true;

      // Update active tab immediately from the target URL
      this.syncActiveTab(new URL(url).pathname);

      // Fade out grid
      this.grid.style.transition = 'opacity 0.15s ease';
      this.grid.style.opacity = '0.4';

      try {
        const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}sections=${this.sectionId}`;
        const res = await fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) throw new Error(res.statusText);

        const data = await res.json();
        const sectionHtml = data[this.sectionId];
        if (!sectionHtml) throw new Error('Section not in response');

        const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const newGrid = doc.querySelector('results-list');
        if (newGrid) {
          this.grid.innerHTML = newGrid.innerHTML;
          // Re-sync active tabs — section render may have reset them
          this.syncActiveTab(new URL(url).pathname);
        }

        if (pushState) history.pushState({}, '', url);
      } catch (_) {
        window.location.href = url;
        return;
      }

      this.grid.style.opacity = '1';
      this.busy = false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => new PlantaTabFilter());
  } catch(e) { console.error(e); }
})();

})();
